module.exports = __webpack_public_path__ + "img/price1.8bf48387.png";